import { apiGate } from '../../services/api_gate'


//Ordenar os operadores da escala
export async function getFasesEtapas(dados) {
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) { console.log('Entrou do getFasesEtapas') }
  const api = await apiGate.post('/crm/fase/fases', dados)
  if (Boolean(process.env.REACT_APP_SHOWLOG === 'true')) console.log('api', api.data)
  return api
}